import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Zap, FileText, Briefcase } from 'lucide-react';
import { requestAddon } from '@/services/apiClient';
import { toast } from 'sonner';

export default function AddonRequestModal({ open, onClose }) {
    const [notes, setNotes] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await requestAddon({ notes });
            toast.success('Add-on request sent to your account manager.');
            setNotes('');
            onClose();
        } catch (err) {
            toast.error(err.message || 'Failed to send add-on request.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Request Add-On Interview Pack</DialogTitle>
                </DialogHeader>
                <div className="space-y-4 py-2">
                    {/* Pack details card */}
                    <div className="rounded-xl border border-primary/30 bg-primary/5 p-4 space-y-3">
                        <div className="flex items-center gap-2">
                            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/15">
                                <Zap className="h-4 w-4 text-primary" />
                            </div>
                            <div>
                                <p className="font-semibold text-foreground">Add-On Interview Pack</p>
                                <p className="text-xs text-muted-foreground">One-time top-up, no plan change required</p>
                            </div>
                            <span className="ml-auto text-lg font-bold text-foreground">₹6,000</span>
                        </div>
                        <div className="grid grid-cols-2 gap-3 border-t border-border pt-3">
                            <div className="flex items-center gap-2 text-sm">
                                <FileText className="h-4 w-4 text-primary" />
                                <span className="font-medium text-foreground">+100 Interviews</span>
                            </div>
                            <div className="flex items-center gap-2 text-sm">
                                <Briefcase className="h-4 w-4 text-primary" />
                                <span className="font-medium text-foreground">+2 Active Jobs</span>
                            </div>
                        </div>
                        <p className="text-xs text-muted-foreground">
                            Credits are added to your current plan limits and do not expire until used.
                        </p>
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="addon-notes">Notes (optional)</Label>
                        <textarea
                            id="addon-notes"
                            placeholder="Any context for your account manager..."
                            value={notes}
                            onChange={e => setNotes(e.target.value)}
                            rows={2}
                            className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 resize-none"
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={onClose} disabled={loading}>Cancel</Button>
                    <Button onClick={handleSubmit} disabled={loading}>
                        {loading ? 'Sending...' : 'Request Add-On'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
